module.exports = "/images/missing-boat-image.png?375cb6f447d3a63f0a5841e404bbd2e1";